import React, { useState } from 'react';
import {
    DragDropContext,
    DragDropContextProps,
    DragUpdate,
    ResponderProvided,
} from 'react-beautiful-dnd';

export const DragDropCtx = React.createContext<DragUpdate>(null);

export interface DragDropProviderProps extends DragDropContextProps {}

export const DragDropProvider: React.FC<DragDropProviderProps> = (props) => {
    const [dragState, setDragState] = useState<DragUpdate>(null);

    function handleDragUpdate(update: DragUpdate, provided: ResponderProvided) {
        setDragState(update);

        if (props.onDragUpdate) {
            props.onDragUpdate(update, provided);
        }
    }

    return (
        <DragDropCtx.Provider value={dragState}>
            <DragDropContext {...props} onDragUpdate={handleDragUpdate} />
        </DragDropCtx.Provider>
    );
};
